import React, { Component } from 'react';
import { Link } from 'gatsby';
import { connect } from 'react-redux';
import * as routes from '../constants/routeNames';
import * as logo_white from '../images/logo_white.png';

const mapStateToProps = (state) => ({
	page: state.thadState.page
});
const mapDispatchToProps = (dispatch) => ({});

interface DispatchProps {}
interface StateProps {
	page: string;
}
interface OwnProps {}

type Props = DispatchProps & StateProps & OwnProps;
type State = {
	open: boolean;
	scrolledToTop: boolean;
	mobile: boolean;
};

const INITIAL_STATE = { open: false, scrolledToTop: true, mobile: false };

class NavBar extends Component<Props, State> {
	private mql;
	constructor(props) {
		super(props);
		this.state = { ...INITIAL_STATE };
		if (typeof window !== 'undefined') {
			this.mql = window.matchMedia('(max-width: 700px)');
			this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
			this.handleScroll = this.handleScroll.bind(this);
		}
	}
	toggle = () => {
		this.setState({ open: !this.state.open });
	};
	componentDidMount() {
		if (typeof window !== 'undefined') {
			window.addEventListener('scroll', this.handleScroll);
			this.mediaQueryChanged();
			this.mql.addListener(this.mediaQueryChanged);
		}
	}
	componentWillUnmount() {
		if (typeof window !== 'undefined') {
			window.removeEventListener('scroll', this.handleScroll);
			this.mql.removeListener(this.mediaQueryChanged);
		}
	}
	mediaQueryChanged() {
		if (this.mql.matches) {
			this.setState({ mobile: true });
		} else {
			this.setState({ mobile: false });
		}
	}
	handleScroll = (event) => {
		if (typeof window !== 'undefined') {
			if (window.scrollY < 30) {
				this.setState({ scrolledToTop: true });
			} else {
				this.setState({ scrolledToTop: false });
			}
		}
	};
	render() {
		const { open, scrolledToTop } = this.state;
		const { page } = this.props;
		return (
			<div
				className={`navbar is-transparent is-fixed-top top-menu ${!scrolledToTop ? 'scrolled' : ''}`}
				id='header'
			>
				<div style={{ height: '100%' }} className='navbar-brand'>
					<Link to={'/'} className='navbar-item logo-title'>
						<img
							data-uk-img
							height={64}
							width={64}
							data-src={logo_white}
							alt='Logo-THAD'
							className='logo-image'
						/>
					</Link>
					<div
						style={{ height: '100%' }}
						className={open ? 'navbar-burger is-active' : 'navbar-burger'}
						data-target='navMenu'
						onClick={this.toggle}
					>
						<span />
						<span />
						<span />
					</div>
				</div>

				<div id='navMenu' className={open ? 'navbar-menu is-active' : 'navbar-menu'}>
					<div className='navbar-start' />
					<div className='navbar-end'>
						<Link
							to='/projects'
							className={`navbar-item menu-item-text ${page === routes.PORTFOLIO ? 'active' : ''}`}
						>
							<div
								className={`${this.state.mobile ? '' : 'inside'} ${page === routes.PORTFOLIO
									? 'active'
									: ''}`}
							>
								Projects
							</div>
						</Link>
						<Link
							to='/work-in-progress'
							className={`navbar-item menu-item-text ${page === routes.PROGRESS ? 'active' : ''}`}
						>
							<div
								className={`${this.state.mobile ? '' : 'inside'} ${page === routes.PROGRESS
									? 'active'
									: ''}`}
							>
								Work In Progress
							</div>
						</Link>
						<Link
							to='/process'
							className={`navbar-item menu-item-text ${page === routes.PROCESS ? 'active' : ''}`}
						>
							<div
								className={`${this.state.mobile ? '' : 'inside'} ${page === routes.PROCESS
									? 'active'
									: ''}`}
							>
								Process
							</div>
						</Link>
						<Link
							to='/about'
							className={`navbar-item menu-item-text ${page === routes.ABOUT ? 'active' : ''}`}
						>
							<div
								className={`${this.state.mobile ? '' : 'inside'} ${page === routes.ABOUT
									? 'active'
									: ''}`}
							>
								About
							</div>
						</Link>
						<Link
							to='/connect'
							className={`navbar-item menu-item-text ${page === routes.CONNECT ? 'active' : ''}`}
						>
							<div
								className={`${this.state.mobile ? '' : 'inside'} ${page === routes.CONNECT
									? 'active'
									: ''}`}
							>
								Connect
							</div>
						</Link>
						<a
							href='https://www.instagram.com/thad.ca/'
							target='_blank'
							rel='noopener'
							className='navbar-item'
						>
							<svg width='24px' height='24px' viewBox='0 0 24 24' version='1.1'>
								<g id='Version2' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
									<path
										d='M12.001125,0 C8.74209106,0 8.3330868,0.01425 7.05307347,0.0725 C5.77556016,0.131 4.90355108,0.33325 4.14054313,0.63 C3.35128491,0.9365 2.68177794,1.3465 2.01477099,2.01375 C1.34726403,2.68075 0.937259763,3.35025 0.62975656,4.13925 C0.332253461,4.9025 0.129751352,5.77475 0.0722507526,7.05175 C0.0150001563,8.33175 0,8.741 0,12 C0,15.259 0.014500151,15.66675 0.0725007552,16.94675 C0.131251367,18.22425 0.333503474,19.09625 0.630006563,19.85925 C0.936759758,20.6485 1.34676403,21.318 2.01402098,21.985 C2.68077792,22.6525 3.3502849,23.0635 4.13904312,23.37 C4.90255107,23.66675 5.77481015,23.869 7.05207346,23.9275 C8.33208679,23.98575 8.74084105,24 11.999625,24 C15.2589089,24 15.6666632,23.98575 16.9466765,23.9275 C18.2241898,23.869 19.0971989,23.66675 19.8607069,23.37 C20.6497151,23.0635 21.3182221,22.6525 21.984979,21.985 C22.652486,21.318 23.0624902,20.6485 23.3699934,19.8595 C23.6649965,19.09625 23.8674986,18.224 23.9274992,16.947 C23.9849998,15.667 24,15.259 24,12 C24,8.741 23.9849998,8.332 23.9274992,7.052 C23.8674986,5.7745 23.6649965,4.9025 23.3699934,4.1395 C23.0624902,3.35025 22.652486,2.68075 21.984979,2.01375 C21.3174721,1.34625 20.6499651,0.93625 19.8599569,0.63 C19.0949489,0.33325 18.2224398,0.131 16.9449265,0.0725 C15.6649132,0.01425 15.2574089,3.55271368e-15 11.997375,3.55271368e-15 L12.001125,0 Z M10.8529214,1.50666667 C11.1937249,1.50613333 11.5739956,1.50666667 12.0012,1.50666667 C15.4188356,1.50666667 15.8239065,1.51893333 17.1735206,1.58026667 C18.4215336,1.63733333 19.0988739,1.84586667 19.5500786,2.02106667 C20.1474182,2.25306667 20.5732893,2.5304 21.0210273,2.9784 C21.469032,3.4264 21.7463682,3.85306667 21.9789039,4.4504 C22.1541058,4.90106667 22.3629079,5.5784 22.4197085,6.8264 C22.4810425,8.17573333 22.494376,8.58106667 22.494376,11.9970667 C22.494376,15.4130667 22.4810425,15.8184 22.4197085,17.1677333 C22.3626413,18.4157333 22.1541058,19.0930667 21.9789039,19.5437333 C21.7469015,20.1410667 21.469032,20.5664 21.0210273,21.0141333 C20.5730226,21.4621333 20.1476849,21.7394667 19.5500786,21.9714667 C19.0994073,22.1474667 18.4215336,22.3554667 17.1735206,22.4125333 C15.8241732,22.4738667 15.4188356,22.4872 12.0012,22.4872 C8.58329774,22.4872 8.17822686,22.4738667 6.82887947,22.4125333 C5.58086647,22.3549333 4.90352608,22.1464 4.45205471,21.9712 C3.85471515,21.7392 3.42804404,21.4618667 2.98003938,21.0138667 C2.53203471,20.5658667 2.25469849,20.1402667 2.02216273,19.5426667 C1.84696091,19.092 1.63815873,18.4146667 1.58135814,17.1666667 C1.52002417,15.8173333 1.50775737,15.412 1.50775737,11.9938667 C1.50775737,8.57573333 1.52002417,8.17253333 1.58135814,6.8232 C1.6384254,5.5752 1.84696091,4.89786667 2.02216273,4.44666667 C2.25416515,3.84933333 2.53203471,3.42266667 2.98003938,2.97466667 C3.42804404,2.52666667 3.85471515,2.24933333 4.45205471,2.0168 C4.90325941,1.8408 5.58086647,1.6328 6.82887947,1.57546667 C8.00969177,1.52213333 8.46729653,1.50613333 10.8529214,1.50346667 L10.8529214,1.50666667 Z M18.0338045,3.632 C17.1857957,3.632 16.4977885,4.3192 16.4977885,5.16746667 C16.4977885,6.01546667 17.1857957,6.70346667 18.0338045,6.70346667 C18.8818134,6.70346667 19.5698205,6.01546667 19.5698205,5.16746667 C19.5698205,4.31946667 18.8818134,3.63146667 18.0338045,3.63146667 L18.0338045,3.632 Z M12.0012,5.42666667 C8.37102886,5.42666667 5.42779821,8.36986667 5.42779821,12 C5.42779821,15.6301333 8.37102886,18.572 12.0012,18.572 C15.6313712,18.572 18.5735351,15.6301333 18.5735351,12 C18.5735351,8.36986667 15.6311045,5.42666667 12.0009333,5.42666667 L12.0012,5.42666667 Z M12.0012001,6.93333333 C14.7992914,6.93333333 17.0679113,9.20161673 17.0679113,12.0000001 C17.0679113,14.7980669 14.7992914,17.0666669 12.0012001,17.0666669 C9.20279217,17.0666669 6.9344889,14.7980669 6.9344889,12.0000001 C6.9344889,9.20161673 9.20279217,6.93333333 12.0012001,6.93333333 L12.0012001,6.93333333 Z'
										id='Instagram'
										fill='#FFFFFF'
									/>
								</g>
							</svg>
						</a>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
